import { useMemo } from 'react'
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import { NAVIGATE_TO } from '@routes'

import { AcBox, AcButton, AcIcon, AcRow } from '@components'
import { ICONS, LABELS } from '@constants'
import { useBreakpoints, useStore } from '@hooks'

interface IAcOrderFooter {
  previousStep?: string
  islastStep?: boolean
  loading?: boolean
  isOrderEdit?: boolean
}

export const AcOrderFooter = ({
  previousStep,
  loading,
  islastStep,
  isOrderEdit = false,
}: IAcOrderFooter) => {
  const { isMobile } = useBreakpoints()
  const navigate = useNavigate()
  const { user } = useStore()

  const renderSubmitLabel = useMemo(() => {
    if (!islastStep) return LABELS.NEXT
    if (isOrderEdit) return LABELS.EDIT_ORDER
    return LABELS.SUBMIT_ORDER
  }, [islastStep, isOrderEdit])

  return (
    <AcRow
      mt={4}
      sx={{
        flexDirection: isMobile ? 'column-reverse' : 'row',
        justifyContent: 'space-between',
        width: '100%',
      }}
      alignItems="center">
      <AcButton
        variant="text"
        disabled={loading}
        onClick={() => navigate(NAVIGATE_TO.ADMIN_DASHBOARD)}>
        {LABELS.CANCEL}
      </AcButton>
      <AcBox
        display="flex"
        gap={4}
        width="100%"
        justifyContent="flex-end"
        flexDirection={isMobile ? 'column-reverse' : 'row'}>
        {previousStep && !user?.isBasicSubscription && (
          <AcButton
            onClick={() => navigate(previousStep)}
            startIcon={<AcIcon icon={ICONS.BACK} />}
            variant="secondary"
            disabled={loading}
            fullWidth={isMobile}>
            {LABELS.BACK}
          </AcButton>
        )}
        <AcButton
          type="submit"
          variant="primary"
          loading={loading}
          fullWidth={isMobile}
          endIcon={!islastStep && <AcIcon icon={ICONS.NEXT} />}>
          {renderSubmitLabel}
        </AcButton>
      </AcBox>
    </AcRow>
  )
}
